{
  "close": "Lukk"
}
